// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyB2ilR1Va9eQIGJwl75Ys0PO7amPKF9V4c",
    authDomain: "motionride-a380a.firebaseapp.com",
    projectId: "motionride-a380a",
    storageBucket: "motionride-a380a.firebasestorage.app",
    messagingSenderId: "228888759840",
    appId: "1:228888759840:web:98c29252ed211ef5197645",
    measurementId: "G-MGNLJ9KN89"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
